import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-flex-cards',
    templateUrl: './block-flex-cards.component.html',
})

export class BlockFlexCardsComponent extends BlockAbstractComponent implements OnInit {

}
